import { Badges } from '../../Badge';

/**
 * Displays a badge with a title below it.
 * @param {Object} props - parameters for function
 * @param {string} props.title - title of the badge
 * @param {object} props.badge - badge object containing type and content
 * @param {string} props.badge.type - type of the badge (e.g., 'info', 'success', etc.)
 * @param {string} props.badge.content - content of the badge
 * @param {string} props.badgeTheme - theme color for the badge
 * @returns {JSX.Element}
 * @description https://www.telerik.com/kendo-react-ui/components/indicators/badge
 */
export const TopCenterBadge = ({ title, badge, badgeTheme = "primary" }) => {
  return (
    <div
      className='d-flex flex-column justify-content-between text-wrap text-center m-0 p-0'
      style={{ height: '130px' }} // container needs explicit height to display inner content properly
    >
      <div>
        {badge && (
          <Badges.Container>
            <Badges.Component
              type={badge.type || 'info'}
              size="small"
              shape="pill"
              themeColor={badgeTheme}
            >
              {badge.content}
            </Badges.Component>
          </Badges.Container>
        )}
      </div>
      <div>{title}</div>
    </div>
  );
};